import { useTranslation } from 'react-i18next';

export default function PackagePage() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">
          <i className="fa fa-gift" /> {t('Packages', 'Packages')}
        </h1>
      </div>
      <div className="form-card">
        <div className="empty-state">
          <i className="fa fa-gift" style={{ fontSize: 48, marginBottom: 12, display: 'block', color: 'var(--mod-package)' }} />
          <p>Packages module — bundled item packages for sale.</p>
          <p className="text-muted">Coming soon</p>
        </div>
      </div>
    </div>
  );
}
